"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */

function size(height) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : height;

  return {
    height: height,
    width: width
  };
}

exports.default = size;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/polished/lib/shorthands/size.js
// module id = 2577
// module chunks = 14